import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { ReportBuilderListDto, ReportMetaDto, ReportRequestDto } from '../report/models';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  getAvailableReports = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, ReportBuilderListDto[]>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: '/api/app/report/available-reports',
    },
    { apiName: this.apiName,...config });
  

  getExport = (key: string, requestDto?: ReportRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, number[]>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: '/api/app/report/export',
      params: { key, skipCount: requestDto.skipCount, maxResultCount: requestDto.maxResultCount, ignoreMaxResultCount: requestDto.ignoreMaxResultCount, clientId: requestDto.clientId, filters: requestDto.filters },
    },
    { apiName: this.apiName,...config });
  

  getList = (key: string, requestDto: ReportRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, object[]>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: '/api/app/report',
      params: { key, skipCount: requestDto.skipCount, maxResultCount: requestDto.maxResultCount, ignoreMaxResultCount: requestDto.ignoreMaxResultCount, clientId: requestDto.clientId, filters: requestDto.filters },
    },
    { apiName: this.apiName,...config });
  

  getMeta = (key: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ReportMetaDto>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: '/api/app/report/meta',
      params: { key },
    },
    { apiName: this.apiName,...config });
}